const HTML_TAG_PATTERN = /<[^>]*>/g;
const NON_BREAKING_SPACE_PATTERN = /&nbsp;/g;

/** True when rich-text markup carries no visible text — an untouched editor still emits `<p><br></p>`. */
export const isRichTextEmpty = (value?: string): boolean =>
  !value
    ?.replace(HTML_TAG_PATTERN, "")
    .replace(NON_BREAKING_SPACE_PATTERN, " ")
    .trim();
